<template>
	<v-container fluid align-start ma-0 pa-2 class="container-height">
		<v-row no-gutters fill-height>
			<v-col cols="12">
				<i-card-vertical :headerTitle="menuTitle" 
                    :class="[setBtnColor]" 
					:useBtnList="useBtnList"
					@btnRetrieve="btnRetrieve()" 
					@btnMakeNdt="btnMakeNdt()" 
                    @btnSaveInfo="btnSaveInfo()" 
					@btnDelete="btnDelete()" >
					<template v-slot:body>
						<v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense>
													<i-label :label="'Supplier name : '"/>
													<v-col cols="4">
														<v-select
															v-model="supName"
															:items="supNameList"
															item-value="supName"
															return-object
															single-line
															outlined
															dense
															@change="supNameChange"
														></v-select>
													</v-col>
												</v-row>
												<v-row dense class="ma-0">
													<i-label :label="'Division : '"/>
													<v-col cols="1">
														<v-select
															v-model="inspDiv"
															:items="inspDivList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<v-col cols="1" class="pl-0">
                            <DxDateBox
                              :value="stDate"
                              height="30px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                            />
													</v-col>
													<i-label :label="'Ship No : '" class="pl-2"/>
													<v-col cols="1">
														<v-select
															v-model="shipNo"
															:items="shipNoList"
															item-value="shipNo"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<i-label :label="'QM Part : '" class="pl-2"/>
													<v-col cols="1" >
														<v-select
															v-model="qmPart"
															:items="qmPartList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
															@change = "cocwNdtList"
														></v-select>
													</v-col>
													<i-label :label="'C.O.C.W : '" class="pl-2"/>
													<v-col cols="1" >
														<v-select
															v-model="wkKind"
															:items="wkKindList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<i-label :label="'NDT Kind : '" class="pl-2"/>
													<v-col cols="1" >
														<v-select
															v-model="ndtKind"
															:items="ndtKindList"
															item-value="code"
															item-text="codeName"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>  
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col cols="12" class="pt-1">
								<DxDataGrid id="v80a1080" 
									:ref="v80a1080Ref"
									class="listBox04"
									:data-source="gridMainList" 
									:remote-operations="false" 
									:hover-state-enabled="true"
									:allow-column-resizing="true" 
									:allow-column-reordering="true"
									:row-alternation-enabled="true" 
									:show-borders="true" 
									:width="grid.width"
									:show-row-lines="true" 
									key-expr="id" 
									:focused-row-enabled="false"
									:column-hiding-enabled="false" 
									:sorting="{ mode: 'none' }"
                                    :selection="{ mode: 'none' }"
									:word-wrap-enabled="true"
									@cellPrepared="cellPrepared"
                                    @editing-start="onEditingStart"
								> 
                  <DxColumn data-field="selChek" data-type="boolean" width="2%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
									<template #selHeader = "{ data: cellInfo }" >
										<DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                  </template>
                  <template #selChkRow = "{ data: cellInfo }">
										<DxCheckBox :value="cellInfo.value" :disabled="cellInfo.data.insResYn === 'Y' ? true : false" 
											:onValueChanged="value => onValueChanged(value, cellInfo)"  />
                  </template> 
									<DxColumn data-field="shipNo" caption="Ship No" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
									<DxColumn data-field="makerNm" caption="Sub-Contract name" width="12%" data-type="string" alignment="left" :allow-editing="false"/>
									<DxColumn data-field="itemDesc" caption="Inspection" width="12%" data-type="string" alignment="left" :allow-editing="false"/>
									<DxColumn data-field="porNo" caption="POR/Seq" width="7%" data-type="string" alignment="left" :allow-editing="false"/>
									<DxColumn data-field="insRes" caption="Result" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
									<DxColumn caption="Req. Date" alignment="center">
										<DxColumn data-field="reqDate" caption="Date" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
										<DxColumn data-field="reqTime" caption="Time" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
									</DxColumn>
									<DxColumn caption="Insp. Date" alignment="center">
										<DxColumn data-field="insDate" caption="Date" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="true"/>
										<DxColumn data-field="insTime" caption="Time" width="5%" data-type="string" alignment="center" :allow-editing="true">
											<DxLookup :data-source="insTimeList" display-expr="timeNm" value-expr="codeName" />
										</DxColumn>
									</DxColumn>
									<DxColumn data-field="ndtKindnm" width="3%" data-type="string" header-cell-template="ndtKind" alignment="center" :allow-editing="false"/>
                  <template #ndtKind >
                    <div>
                      <span>NDT<br>Kind</span>
                    </div>
                  </template>
									<DxColumn data-field="wkKindnm" caption="C.O.C.W" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
									<DxColumn data-field="insLocNm" caption="Location" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
									<DxColumn data-field="ndtNo" caption="NDT No" width="5%" data-type="string" alignment="center" :allow-editing="true"/>
									<DxColumn data-field="wedEmpnm" caption="Welder" width="9%" data-type="string" alignment="center" :allow-editing="false"/>

									<DxPaging :enabled="true" :page-size="16" />
                  <DxPager :visible="true" :showInfo="false" />
								</DxDataGrid>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<v-row no-gutters>
									<v-col cols="12" class="subText">Count Total: {{ listSize }} Row(s)</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</i-card-vertical>
			</v-col>
		</v-row>
		<v80a1080MPop :makePop.sync="makePop" 
			:makePopData="makePopData"
			:supNameList="supNameList"
			:shipNoListPop="shipNoList"
			:insTimeListPop="insTimeList"
			:ndtKindListPop="ndtKindList"
			:qmPartListPop="qmPartList"
			:inspLocListPop="inspLocList"
			:wkKindListPop="wkKindList"
			@isSaved="request($event)"
		/>
		<v80a1080HPop :makePop2.sync="makePop2" 
			:makePopData="makePopData"
			:supNameList="supNameList"
			:shipNoListPop="shipNoList"
			:insTimeListPop="insTimeList"
			:ndtKindListPop="ndtKindList"
			:qmPartListPop="qmPartList"
			:inspLocListPop="inspLocList"
			:wkKindListPop="wkKindList"
			@isSaved="request($event)"
		/>
		
	</v-container>
</template>
	
<script>
import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getSupplier , getV80ShipNo } from '@/api/view/hip/8/v80a1040.js'
import { v80CocwNdt , v80a1080List , v80a1080Update , v80a1080Delete } from '@/api/view/hip/8/v80a1080.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getDateFormat } from '@/utils/common.js'
import dayjs from 'dayjs'
import notify from 'devextreme/ui/notify' // message
import v80a1080MPop from '@/views/hip/8/popup/v80a1080MPop'
import v80a1080HPop from '@/views/hip/8/popup/v80a1080HPop'

export default {
	name: 'v80a1080',
	mixins: [baseview, BaseDataGrid],
	components: {
		ICardVertical,
		"i-card-top": iCardTop,
		DxDataGrid,
		DxColumn,
		DxEditing,
		DxDateBox,
		DxLookup,
		DxSelection,
		DxPager,
		v80a1080MPop,
		v80a1080HPop
	},
	data() {
		return {
			menuTitle: this.$route.meta.title,
			useBtnList: ['btnRetrieve', 'btnMakeNdt', 'btnSaveInfo', 'btnDelete'],
			v80a1080Ref: 'v80a1080Ref',
			gridMainList: [],
			setBtnColor: 'setBtnColor',

			stDate: '',

			supName: '',
			supNameList: [],
			inspDiv: '',
			inspDivList: [],
			shipNo: '',
			shipNoList: [],
			blockNo: '',
			qmPart: '',
			qmPartList: [],
			wkKind: '',
			wkKindList: [],
			ndtKind: '',
			ndtKindList: [],
			inspLocList: [],

			custCd: '',
			respCd: '',

			listSize: 0,

			insTimeList: [],
			lqcMemberList: [],

			makePop: false,
			makePop2: false,
			makePopData: [],

			kindInspList:[],

		}
	},
	computed: {
		gridMainInstance() {
			return this.GetDataGrid(this.v80a1080Ref)
		},
	},
	beforeMount(){
		let params = {
			makerCd: this.$store.state.user.makerCd,
			code: '',
			codegr: '',
			prtCode: 'TIME_INSP',
			userFlag: 'Y',
		}
		//inspTimeList
		Promise.all([
		getCmChildCode(params)]).then(res => {
			res[0].list.forEach(e => {
				if(e.codeName != null){
					e.timeNm = e.codeName.substring(0,2) + ':' +  e.codeName.substring(2)
				} else {
					e.timeNm = ''
				}
			});
			this.insTimeList = res[0].list
		}).catch(error => {}) 

		let params2 = {
			code: '',
			codegr: '',
			prtCode: 'INSP_LOC',
			userFlag: 'Y',
		}
		Promise.all([
		getCmChildCode(params2)]).then(res => {
			this.inspLocList = res[0].list
		}).catch(error => {}) 
	},
	mounted() {
		this.init()
		this.gridMainInstance.option('defaultPaging', false)
	},
	methods: {
		getStrFormat(date) {
			this.stDate = date
			return getDateFormat(date)
		},
		init(){
			let toDay = new Date
			toDay.setDate(toDay.getDate() + 1);
			this.stDate = toDay

			this.getList()
			
			if(this.$store.state.user.userGrd !== 'A'){
				this.supNameChange()
			}
		},
		async getList(){
			try {
				this.openLoading('searching')
				let params = {
					// makerCd: this.$store.state.user.userGrd !== 'A' ? this.custCd : '%',
					makerCd: this.$store.state.user.userGrd !== 'A' ? this.$store.state.user.makerCd : '%',
					code: '',
					codegr: '',
					prtCode: 'INSP_DIV',
					userFlag: 'Y',
					shipGu: ''
				}
				let params2 = {
					code: '',
					codegr: '',
					prtCode: 'QC_PART',
					userFlag: 'Y'
				}
				let params3 = {
					code: '',
					codegr: '',
					prtCode: 'NDT_KIND',
					userFlag: 'Y'
				}

				await getSupplier(params).then(res => {
					// this.supNameList.push('Select Supplier')
					if (this.$store.state.user.userGrd == 'A') {
						this.supNameList.push('Select Supplier')
					}  
					res.list.forEach(e => {
						this.supNameList.push(e.custCd + ' : ' + e.custNm)
					});
					this.supName = this.supNameList[0]
				})

				await getCmChildCode(params).then(res => {
					res.list.forEach(e => {
						this.inspDivList.push(e)
					});
					this.inspDiv = this.inspDivList[0].code
				})

				getV80ShipNo(params).then(res => {
					this.shipNoList.push('All')
					res.list.forEach(e => {
						this.shipNoList.push(e.shipNo)
					});
					this.shipNo = this.shipNoList[0]
				})

				getCmChildCode(params2).then(res => {
					this.qmPartList.push({codeName: 'All' , code: ''})
					res.list.forEach(e => {
						this.qmPartList.push(e)
					});
				})

				getCmChildCode(params3).then(res => {
					this.ndtKindList = res.list
					this.ndtKind = this.ndtKindList[0].code
				})

			} finally {
				this.cocwNdtList()
				this.endLoading()
			}
		},
		cocwNdtList(){
			this.wkKindList = []
			let params = {
				qmPart: !this.qmPart.code ? '' : this.qmPart.code
			}

			console.log('C.O.C.W 1080: ', params)

			v80CocwNdt(params).then(res => {
				this.wkKindList.push({code: '' , codeName: 'All...'})
				res.list.forEach(e => {
					e.codeName = e.wkKind + ' : ' + e.wkKindnm
					e.code = e.wkKind
					this.wkKindList.push(e)
				});
			})
		},
		async getMainList(){
			try {
				this.openLoading('searching')
				let params = {
					shipNo: this.shipNo == 'All' ? '' : this.shipNo,
					makerCd: this.custCd,
					inspDiv: this.inspDiv,
					stDate: dayjs(this.stDate).format('YYYY-MM-DD'),
					qmPart: !this.qmPart.code ? '' : this.qmPart.code,
					block: !this.blockNo ? '' : this.blockNo,
					ndtKind: !this.ndtKind.code ? '' : this.ndtKind.code,
					wkKind: !this.wkKind.wkKind ? '' : this.wkKind.wkKind
				}
				await v80a1080List(params).then(res => {
					let cnt = 1;
					res.list.forEach(e => {
						e.selChek = false
						e.id = cnt++
						e.porNo = (!e.porNo ? '' : e.porNo ) + '-' + (!e.porSeq ? '' : e.porSeq)
					});
					this.gridMainList = res.list
					this.listSize = res.list.length
				})

			} finally {
			this.endLoading()
			}
		},
		supNameChange(){
			let supNameGbn = this.supName
			supNameGbn = supNameGbn.split(' : ')
			// this.custCd = supNameGbn[0]

			if(this.$store.state.user.userGrd !== 'A'){
				this.custCd = this.$store.state.user.makerCd
			}else{
				this.custCd = supNameGbn[0]
			}

			this.btnRetrieve()
		},
		uppercase(){
			if(!this.porNo){
				this.porNo = this.porNo.toUpperCase()
			}
		},
		btnRetrieve(){
			this.cocwNdtList()
			this.getMainList()
		},
		btnMakeNdt(){
			this.makePopData = []
			if(!this.custCd){
				this.vToastify(this.$t('Please, select a Sub-Contract!!'), 'warn')
				return
			}
			if(this.shipNo === null || this.shipNo === 'All'){
				this.vToastify(this.$t('Please, select a Ship No!!'), 'warn')
				return
			}
			if(!this.qmPart.code){
				this.vToastify(this.$t('Please, select a QM Part!!'), 'warn')
				return
			}
			if(!this.wkKind.wkKind){
				this.vToastify(this.$t('Please, select a C.O.C.W!!'), 'warn')
				return
			}
			if(!this.ndtKind.code || this.ndtKind.code === '%'){
				this.vToastify(this.$t('Please, select a NDT kind!!'), 'warn')
				return
			}
			let param = {
				supName: this.supName,
				qmPart: this.qmPart.code,
				ndtKind: this.ndtKind,
				shipNo: this.shipNo,
				stDate: this.stDate,
				wkKind: this.wkKind,
				inspDiv: this.inspDiv
			}
			this.makePopData.push(param)

			if(this.qmPart.code === 'M'){
				this.makePop = true
			}else {
				this.makePop2 = true

			}

		},
		async btnSaveInfo(){
			await this.gridMainInstance.saveEditData()
			var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
			let toDay = new Date()
			toDay.setDate(toDay.getDate() + 1);
			toDay = dayjs(toDay).format('YYYY-MM-DD')

			if(!selectedMainRows.length){
				this.vToastify(this.$t('Data is not selected.'), 'warn')
				return
			}
			
			for (var row of selectedMainRows){
				if(!row.insDate){
					this.vToastify(this.$t('Select Inspection Date.'), 'warn')
					return
				}
				if(!row.insTime){
					this.vToastify(this.$t('Select Inspection Time.'), 'warn')
					return
				}
				row.userId = this.$store.state.user.userId
				row.insDate = dayjs(row.insDate).format('YYYY-MM-DD')
			}

			this.openLoading('searching')
			v80a1080Update(selectedMainRows).then(res => {
				if(res.body === 'Y'){
					notify(this.$t('Request NDT Update is completed.'), 'success', 3000)
				} else {
					this.vToastify(this.$t('An error has been occurred while update data :' + res.body), 'warn')
				}
			})
			.catch(error => {
				this.vToastify(error, 'warn')
			})
			.finally(() => {
				this.gridMainInstance.clearSelection()
				this.btnRetrieve()
				this.endLoading()
			})
		},
		async btnDelete(){
			if(this.gridMainList.length > 0){
				await this.gridMainInstance.saveEditData()
				var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
				if(!selectedMainRows.length){
					this.vToastify(this.$t('Data is not selected.'), 'warn')
					return
				}
				try {
					this.openLoading('searching')

					this.vToastifyPrompt(
						this.$t('Do you want to delete the data?'),
						'info',
							curr => {
								v80a1080Delete(selectedMainRows).then(res => {
									if(res.body === 'OK'){
										notify(this.$t('Deleting data is completed.'), 'success', 3000)
									} else {
										this.vToastify(this.$t('An error has been occurred while deleting data.'), 'warn')
									}
								})
								.catch(error => {
									this.vToastify(error, 'warn')
								})
								.finally(() => {
									this.gridMainInstance.clearSelection()
									this.btnRetrieve()
								})
							}
							,
						null,
						true
					)
				} finally {
					this.endLoading()
				}
			}
		},
		request(e){
			let filter = []
			filter = e.custCd.split(' : ')

			this.shipNo = e.shipNo
			this.custCd = filter[0]
			this.inspDiv = e.inspDiv
			// this.qmPart = e.qmPart
			this.stDate = e.stDate
			this.ndtKind = e.ndtKind
			this.wkKind = e.wkKind
			this.getMainList()
		},
		onEditingStart(e){
			if(e.data.insResYn === 'Y'){
				e.cancel = true
			}
		},
		async onValueChanged(value, cellInfo){
			if(cellInfo.rowType === 'header') {
				for(let i = 0; i < this.gridMainList.length; i++) {
					let insResYn = await this.gridMainInstance.byKey(i+1)
					if(insResYn.insResYn != 'Y'){
						this.gridMainList[i].selChek = value.value
						if(value.value) {
							this.gridMainInstance.selectRows(i+1 , true)
						} else {
							this.gridMainInstance.deselectAll()
						}
					}
				}
			} else {
				this.gridMainList[cellInfo.rowIndex].selChek = value.value
				if(value.value) {
					this.gridMainInstance.selectRows([cellInfo.rowIndex + 1], true)
				} else {
					this.gridMainInstance.deselectRows([cellInfo.rowIndex + 1])
				}
			}

		},
		cellPrepared(e){
			if(e.rowType === 'data'){
				if(e.data.insResYn === 'Y'){
					e.cellElement.style.backgroundColor = '#00FF00'
				}
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.subText{
	font-weight: bold;
	color: black;
}

$redBtn: #FF0000;
.setBtnColor::v-deep {
	[role=btnDelete]{
		.v-btn__content {
			div {
				color: #{$redBtn} !important;
			}

			i {
				color: #{$redBtn} !important;
			}
		}
	}
}
</style>